import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { APP_URL } from '@helpers/variables'
import Button from '@components/Button'
import {
  BUTTON_SIZE,
  BUTTON_TYPE,
  COLORS,
  DIVIDER_SIZE,
  HEADING_TYPE,
  TEXT_SIZES,
} from '@helpers/constants'
import Divider from '@components/Divider'
import Text from '@components/Text'
import Heading from '@components/Heading'

const RegisterStudentLink = (props) => {
  const { school, schoolClass } = props

  const [linkCopied, setLinkCopied] = useState(false)

  if (!school || !schoolClass) return null

  const registerLink = `${APP_URL}/registrera-elev?s=${school.id}&c=${schoolClass.id}`

  return (
    <div className={'max-w-[450px] grid-cols-2'}>
      <Heading headingLevel={HEADING_TYPE.H1} size={TEXT_SIZES.XXLARGE}>
        Låt elever skriva in sig i klassen
      </Heading>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <Text>
        Ge denna länk till de elever som ska tillhöra klassen (till exempel kopiera och klistra in i ett mejl).
      </Text>

      <div className={'inline-block mt-2 py-2 pl-4 pr-10 bg-lightLightGrey'}>
        {registerLink}
      </div>

      <Divider size={DIVIDER_SIZE.SMALL} />

      <div className={'flex items-center'}>
        <Button
          type={BUTTON_TYPE.PRIMARY}
          size={BUTTON_SIZE.LARGE}
          handleClick={() => {
            navigator.clipboard.writeText(registerLink)
            setLinkCopied(true)
          }}
        >
          Kopiera länk
        </Button>

        {linkCopied && (
          <Text extraClasses={'ml-4'} color={COLORS.LIGHT_DARK_GREY.TEXT}>
            Länk kopierad!
          </Text>
        )}
      </div>
    </div>
  )
}

RegisterStudentLink.propTypes = {
  school: PropTypes.object,
  schoolClass: PropTypes.object,
}

export default RegisterStudentLink
